<template>
  <div>
    <PageAllow controller="StockOrderAnalyze" action="index" />
    <Breadcrumbs :items="items" />
    <v-slide-x-transition>
      <v-sheet class="transparent-background-color">
        <v-row dense class="mx-5">
          <v-col cols="12" sm="12" md="4">
            <v-row dense align="center" class="pa-1">
              <!-- 出库日期 / 时间类型 -->
              <SearcherDatetimeRangeWithRadio
                v-model="outDatetimeRange"
                type="datetime"
                show-radios
                :radios="timeSyncFlg ? DatetimeRadios : outDatetimeRadios"
                removeIcon
                switchIcon
                @switchAction="timeSyncFlg = !timeSyncFlg"
                :timeSyncFlg="timeSyncFlg"
              />
            </v-row>
            <v-row dense align="center" class="pa-1" v-if="!timeSyncFlg">
              <!-- 入库时间 -->
              <SearcherDatetimeRangeWithRadio
                v-model="inDatetimeRange"
                type="datetime"
                show-radios
                :radios="inDatetimeRadios"
                removeIcon
              />
            </v-row>
          </v-col>
          <v-col cols="12" sm="12" md="8" align-self="center">
            <v-row dense align="center" class="search-controls">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    small
                    text
                    class="px-0 py-0 caption font-weight-bold grey--text"
                    color="primary"
                    @click.stop="onSearch()"
                  >
                    <v-icon small class="pe-1">fa-search</v-icon>
                    {{ $t("Search.search") }}
                  </v-btn>
                </template>
                <span>{{ $t("Search.searchTip") }}</span>
              </v-tooltip>
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    small
                    text
                    class="caption font-weight-bold grey--text"
                    @click.stop="resetSearch()"
                  >
                    <v-icon x-small class="pe-1">fa-trash-alt</v-icon>
                    {{ $t("Search.reset") }}
                  </v-btn>
                </template>
                <span>{{ $t("Search.resetTip") }}</span>
              </v-tooltip>
              <v-divider vertical />
              <v-btn
                class="caption font-weight-bold grey--text"
                :class="
                  $vuetify.theme.dark ? 'text--lighten-1' : 'text--darken-1'
                "
                small
                text
                @click.stop="$store.commit('toggleSearchPanel')"
              >
                {{ $t("Search.pro") }}
                <v-icon small class="ps-1">{{
                  $store.state.showSearchPanel ? "fa-angle-up" : "fa-angle-down"
                }}</v-icon>
              </v-btn>
              <v-spacer />
              <!-- 导出 按钮 -->
              <v-btn
                v-if="
                  $permission.permissionAllow(
                    'StockOrderAnalyze',
                    'detailExport'
                  )
                "
                small
                color="print"
                dark
                class="ms-1"
                href=""
                @click.stop="exportExcel()"
              >
                <v-icon x-small class="pe-1">fa-file-export</v-icon>
                {{ $t("inOutDetail.Export.excel") }}
              </v-btn>
              <!-- 江西定制 -->
              <v-btn
                v-if="
                  $permission.permissionAllow(
                    'StockOrderAnalyze',
                    'detailJiangXiExport'
                  )
                "
                small
                color="print"
                dark
                class="ms-1"
                href=""
                @click.stop="exportExcelJX()"
              >
                <v-icon x-small class="pe-1">fa-file-export</v-icon>
                {{ $t("inOutDetail.Export.excel") }}
              </v-btn>
            </v-row>
          </v-col>
        </v-row>
        <v-expansion-panels
          v-model="$store.getters.panels"
          multiple
          flat
          accordion
        >
          <v-expansion-panel class="transparent-background-color">
            <v-expansion-panel-content>
              <v-row dense align="center">
                <!-- 仓库组别 -->
                <v-col cols="12" sm="6" md="4">
                  <SearcherStockDistrict v-model="stockDistrictSelected" />
                </v-col>
                <!-- 仓配 -->
                <v-col cols="12" sm="6" md="4">
                  <SearcherStock
                    v-model="stocksSelected"
                    :stock-district="stockDistrictSelected"
                  />
                </v-col>
                <!-- 供应商 -->
                <v-col cols="12" sm="6" md="4">
                  <SearcherSupplier v-model="supplierSelected" />
                </v-col>
                <!-- 商品 -->
                <v-col cols="12" sm="6" md="4">
                  <SearcherMaterials v-model="materialSelected" returnId />
                </v-col>
                <v-col cols="12" sm="6" md="4">
                  <SearcherShop v-model="shopSelected" />
                </v-col>
                <!-- 类型 -->
                <v-col cols="12" sm="6" md="4">
                  <SearcherStatus
                    v-model="options.order_flg"
                    :label="$t('inOutDetail.type.ObjectName')"
                    :items="$consts.outInFlgs"
                  />
                </v-col>
              </v-row>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
        <!-- 表格 -->
        <div class="mx-4 mb-4">
          <v-data-table
            :headers="headers"
            :items="in_out_detail"
            :options.sync="options"
            :loading="loading"
            :page.sync="paging.page"
            :server-items-length="paging.count"
            multi-sort
            fixed-header
            class="elevation-1 px-4 pt-1 sticky-table"
            :footer-props="$t('$config.footer-props')"
          >
            <!-- 单号 -->
            <template v-slot:item.code="{ item }">
              <!-- 跳转批次报损详情 -->
              <a
                class="text-no-wrap caption font-weight-bold"
                v-if="item.order_flg == 1 && item.type == 14"
                @click.stop="$router.push({})"
              >
                {{ item.stock_order_code }}
              </a>
              <!-- 跳转出库单详情 -->
              <a
                class="text-no-wrap caption font-weight-bold"
                v-else-if="item.order_flg == 1 && item.type != 14"
                @click.stop="
                  $router.push({
                    path: '/stock-orders-out/' + item.stock_order_id,
                  })
                "
              >
                {{ item.stock_order_code }}
              </a>
              <!-- 跳转入库单详情 -->
              <a
                class="text-no-wrap caption font-weight-bold"
                v-else-if="item.order_flg == 2"
                @click.stop="
                  $router.push({
                    path: '/stock-orders-in/' + item.stock_order_id,
                  })
                "
              >
                {{ item.stock_order_code }} </a
              ><br />
              <span
                class="text-no-wrap caption secondary--text"
                :class="
                  $vuetify.theme.dark ? 'text--lighten-1' : 'text--darken-1'
                "
              >
                {{ item.created | formatTime }}
              </span>
            </template>
            <!-- 门店 -->
            <template v-slot:item.supplier_name="{ item }">
              <span
                v-if="
                  (item.order_flg == 1 && item.type == 1) ||
                  (item.order_flg == 2 && item.type == 1)
                "
              >
                {{ item.shop_name }}<br />
                {{ item.shop_code }}
              </span>
              <span v-else-if="item.order_flg == 2 && item.type == 11">
                {{ item.supplier_name }}
              </span>
              <span v-else-if="item.order_flg == 1 && item.type == 13">
                {{ item.supplier_name }}
              </span>
              <span
                v-else-if="
                  item.order_flg == 1 && item.type != 1 && item.type != 13
                "
              >
                {{ item.out_type_str }}
              </span>
              <span
                v-else-if="
                  item.order_flg == 2 && item.type != 1 && item.type != 11
                "
              >
                {{ item.in_type_str }}
              </span>
            </template>
            <!-- 商品 -->
            <template v-slot:item.material_name="{ item }">
              {{ item.material_name }}
              <br />
              <span v-if="item.standard_name" class="caption secondary--text">
                {{ $t("Material.Fields.standard") }}{{ $t("Global.colon") }}
                <span
                  v-if="item.standard_name && item.standard_name.length > 12"
                  :title="item.standard_name"
                  style="cursor: pointer"
                >
                  {{ item.standard_name.slice(0, 12) + "......" }}
                </span>
                <span v-else>
                  {{ item.standard_name }}
                </span>
              </span>
            </template>
            <!-- 出入库类型 -->
            <template v-slot:item.order_flg="{ item }">
              <v-chip
                small
                label
                :color="item.order_flg | outInFlgsColor"
                :text-color="item.order_flg | outInFlgsTextColor"
              >
                {{ item.order_flg | outInFlgsText }}
              </v-chip>
            </template>
            <template v-slot:header.actions="{ header }">
              {{ header.text }}
              <v-icon x-small>fa-sliders-h</v-icon>
            </template>
            <!-- 出入库 -->
            <template v-slot:item.order_num="{ item }">
              {{ item.order_num | formatTwoDot }}{{ item.unit }}
            </template>
            <!-- 基准单位出入库 -->
            <template v-slot:item.order_default_num="{ item }">
              <span v-if="item.status == 3">
                <span v-if="item.unit != item.default_unit">
                  {{ item.default_num | formatTwoDot }}{{ item.default_unit }}
                </span>
              </span>
            </template>

            <!-- 实际出入库 -->
            <template v-slot:item.actual_num="{ item }">
              <span v-if="item.shelved_num == 0">
                {{ item.actual_num | formatTwoDot }}{{ item.unit }}
              </span>
              <span
                v-else-if="
                  item.shelved_num != 0 && item.shelved_num % item.rate == 0
                "
              >
                {{ parseInt(item.shelved_num / item.rate) | formatTwoDot
                }}{{ item.unit }}
              </span>
              <span
                v-else-if="
                  item.shelved_num != 0 && item.shelved_num % item.rate != 0
                "
              >
                {{ parseInt(item.shelved_num / item.rate) }}{{ item.unit
                }}{{ $t("inOutDetail.quantity")
                }}{{ item.shelved_num % item.rate }}{{ item.default_unit }}
              </span>
            </template>

            <!-- 单价 -->
            <template v-slot:item.price="{ item }">
              {{ $t("Global.money") }}{{ item.price | formatMoney }}
            </template>
            <!-- 小计 -->
            <template v-slot:item.sub_total="{ item }">
              {{ $t("Global.money") }}{{ item.sub_total | formatMoney }}
            </template>
            <!-- 出入库完成时间 -->
            <template v-slot:item.finish_time="{ item }">
              {{ item.finish_time | formatTime }}
            </template>
          </v-data-table>
        </div>
      </v-sheet>
    </v-slide-x-transition>
  </div>
</template>

<script>
import { mapState } from "vuex";
import PageAllow from "@/components/PageAllow";
import i18n from "@/i18n";
import Breadcrumbs from "@/components/Breadcrumbs";
import SearcherDatetimeRangeWithRadio from "@/components/plugins/SearcherDatetimeRangeWithRadio";
import stockOrderAnalyze from "@/api/stock_order_analyze";
import SearcherSupplier from "@/components/plugins/SearcherSupplier";
import SearcherStatus from "@/components/plugins/SearcherStatus";
import SearcherStockDistrict from "@/components/plugins/SearcherStockDistrict";
import SearcherMaterials from "@/components/plugins/SearcherMaterials";
import SearcherStock from "@/components/plugins/SearcherStock";
import SearcherShop from "@/components/plugins/SearcherShop";

const defaultOptions = {
  out_create_time_from: "",
  out_create_time_to: "",
  out_actual_time_from: "",
  out_actual_time_to: "",
  out_finish_time_from: "",
  out_finish_time_to: "",
  in_create_time_from: "",
  in_create_time_to: "",
  in_actual_time_from: "",
  in_actual_time_to: "",
  in_finish_time_from: "",
  in_finish_time_to: "",
  stock_districts: null,
  supply_id: null,
  material_ids: [],
  stock_id: null,
  order_flg: [1, 2],
  shop_id: null,
};

const defaultOutDatetimeRange = {
  datetimeRadioSelected: "out_create",
  out_create_time_from:
    new Date(new Date().getTime() - 30 * 24 * 3600 * 1000)
      .toISOString()
      .substr(0, 10) + " 00:00:00",
  out_create_time_to: new Date().toISOString().substr(0, 10) + " 23:59:59",
  out_actual_time_from: "",
  out_actual_time_to: "",
  out_finish_time_from: "",
  out_finish_time_to: "",
};
const defaultInDatetimeRange = {
  datetimeRadioSelected: "in_create",
  in_create_time_from:
    new Date(new Date().getTime() - 30 * 24 * 3600 * 1000)
      .toISOString()
      .substr(0, 10) + " 00:00:00",
  in_create_time_to: new Date().toISOString().substr(0, 10) + " 23:59:59",
  in_actual_time_from: "",
  in_actual_time_to: "",
  in_finish_time_from: "",
  in_finish_time_to: "",
};

export default {
  name: "stockOrderAnalyzeDetails",
  data: () => ({
    in_out_detail: [],
    supplierSelected: {},
    stocksSelected: null,
    materialSelected: null,
    stockDistrictSelected: null,
    paging: {},
    options: JSON.parse(JSON.stringify(defaultOptions)),
    loading: false,
    outDatetimeRange: JSON.parse(JSON.stringify(defaultOutDatetimeRange)),
    inDatetimeRange: JSON.parse(JSON.stringify(defaultInDatetimeRange)),
    timeSyncFlg: true,
    shopSelected: null,
  }),
  components: {
    Breadcrumbs,
    SearcherStock,
    SearcherDatetimeRangeWithRadio,
    PageAllow,
    SearcherSupplier,
    SearcherStatus,
    SearcherStockDistrict,
    SearcherMaterials,
    SearcherShop,
  },
  props: {
    detailMode: Boolean,
  },
  computed: {
    ...mapState(["settings"]),
    items: () => [
      {
        text: i18n.t("Nav.home"),
        disabled: false,
        href: "/home",
      },
      {
        text: i18n.t("Nav.stockManagement"),
        disabled: false,
        href: "/stocks",
      },
      {
        text: i18n.t("Nav.stockOrderAnalyze"),
        disabled: false,
        href: "/stock-order-analyze",
      },
      {
        text: i18n.t("Nav.inOutDetail"),
        disabled: true,
      },
    ],
    outDatetimeRadios: () => [
      {
        key: "out_create",
        text: i18n.t("stockOrderAnalyze.Fields.out_created_time"),
      },
      {
        key: "out_actual",
        text: i18n.t("stockOrderAnalyze.Fields.out_actual_time"),
      },
      {
        key: "out_finish",
        text: i18n.t("stockOrderAnalyze.Fields.out_complete_time"),
      },
    ],
    DatetimeRadios: () => [
      {
        key: "out_create",
        text: i18n.t("stockOrderAnalyze.Fields.created_time"),
      },
      {
        key: "out_actual",
        text: i18n.t("stockOrderAnalyze.Fields.actual_time"),
      },
      {
        key: "out_finish",
        text: i18n.t("stockOrderAnalyze.Fields.complete_time"),
      },
    ],
    inDatetimeRadios: () => [
      {
        key: "in_create",
        text: i18n.t("stockOrderAnalyze.Fields.in_created_time"),
      },
      {
        key: "in_actual",
        text: i18n.t("stockOrderAnalyze.Fields.in_actual_time"),
      },
      {
        key: "in_finish",
        text: i18n.t("stockOrderAnalyze.Fields.in_complete_time"),
      },
    ],
    headers: () => [
      {
        text: i18n.t("inOutDetail.Fields.stock_name"),
        align: "start",
        sortable: false,
        width: "105px",
        class: "text-no-wrap",
        value: "stock_name",
      },
      // 门店 供应商
      {
        text: i18n.t("inOutDetail.Fields.supplier_name"),
        align: "center",
        width: "190px",
        sortable: false,
        value: "supplier_name",
      },
      // 单号
      {
        text: i18n.t("inOutDetail.Fields.code"),
        align: "center",
        sortable: false,
        width: "195px",
        value: "code",
      },
      {
        text: i18n.t("inOutDetail.Fields.material_code"),
        align: "center",
        sortable: false,
        value: "material_code",
      },
      {
        text: i18n.t("inOutDetail.Fields.material_name"),
        align: "start",
        sortable: false,
        width: "265px",
        value: "material_name",
      },
      {
        text: i18n.t("inOutDetail.Fields.order_flg_str"),
        align: "center",
        sortable: false,
        value: "order_flg",
      },
      // 单价
      {
        text: i18n.t("inOutDetail.Fields.price"),
        align: "center",
        sortable: false,
        value: "price",
      },
      // 出入库量
      {
        text: i18n.t("inOutDetail.Fields.order_num"),
        align: "center",
        // width: "100px",
        class: "text-no-wrap",
        sortable: false,
        value: "order_num",
      },
      // 实际 出入库量
      {
        text: i18n.t("inOutDetail.Fields.actual_num"),
        align: "center",
        // width: "120px",
        class: "text-no-wrap",
        sortable: false,
        value: "actual_num",
      },
      // 基准单位出入库量
      {
        text: i18n.t("inOutDetail.Fields.order_default_num"),
        align: "center",
        // width: "100px",
        class: "text-no-wrap",
        sortable: false,
        value: "order_default_num",
      },
      // 小计
      {
        text: i18n.t("inOutDetail.Fields.sub_total"),
        align: "center",
        sortable: false,
        value: "sub_total",
      },
      // 库存
      {
        text: i18n.t("inOutDetail.Fields.stock_current_str"),
        align: "center",
        sortable: false,
        value: "stock_current_str",
      },
      // 出入库完成时间
      {
        text: i18n.t("inOutDetail.Fields.finish_time"),
        align: "center",
        sortable: false,
        value: "finish_time",
      },
      // 操作人
      {
        text: i18n.t("inOutDetail.Fields.executer_name"),
        align: "start",
        sortable: false,
        width: "120px",
        value: "executer_name",
      },
    ],
  },

  mounted() {
    this.$commonUtils
      .loadOptions("stockIN-and-stockOUT", [
        //"supplierSelected", //供应商
        "stocksSelected", //仓库
        "stockDistrictSelected", //仓库分组
        // "materialSelected",//商品
        "outDatetimeRange",
        "inDatetimeRange",
        "timeSyncFlg",
        "shopSelected",
      ])
      .then(
        function (data) {
          if (data.options) {
            this.options = data.options;
          }
          // this.resetSearch();
          this.options.material_ids = [this.$route.params.id];
          this.options.order_flg = [1, 2];
          data.selecteds.forEach((selected) => {
            switch (selected.key) {
              case "stockDistrictSelected":
                this.stockDistrictSelected = selected.value;
                break;
              case "stocksSelected":
                this.stocksSelected = selected.value;
                break;
              case "outDatetimeRange":
                this.outDatetimeRange = selected.value;
                break;
              case "inDatetimeRange":
                this.inDatetimeRange = selected.value;
                break;
              case "timeSyncFlg":
                this.timeSyncFlg = selected.value;
                break;
              case "shopSelected":
                this.shopSelected = selected.value;
                break;
              // case "supplierSelected":
              //   this.supplierSelected = selected.value;
              //   break;
              // case "materialSelected":
              //   this.materialSelected = selected.value;
              //   break;
            }
          });
        }.bind(this)
      );
  },
  methods: {
    onSearch() {
      // 搜索
      this.options = Object.assign({}, this.options);
    },
    resetSearch() {
      this.stockDistrictSelected = null;
      this.supplierSelected = {};
      this.materialSelected = null;
      this.stocksSelected = null;
      this.shopSelected = null;
      this.options = JSON.parse(JSON.stringify(defaultOptions));
      this.outDatetimeRange = JSON.parse(
        JSON.stringify(defaultOutDatetimeRange)
      );
      this.inDatetimeRange = JSON.parse(JSON.stringify(defaultInDatetimeRange));
    },
    getStockOrderAnalyzeFromAPI() {
      this.loading = true;
      stockOrderAnalyze.fetchOne(this.$route.params.id, this.options).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.in_out_detail = response.data.in_out_detail;
            this.paging = response.data.paging;
          } else if (response.data.error.code.isNoResultSet()) {
            this.options.page = 1;
          }
          this.loading = false;
        }.bind(this)
      );
    },
    exportExcel() {
      stockOrderAnalyze.exports(this.options);
    },
    exportExcelJX() {
      stockOrderAnalyze.detailJiangXiExport(this.options);
    },
  },
  watch: {
    $route: {
      immediate: true,
      handler() {
        this.materialSelected = [Number(this.$route.params.id)];
      },
    },
    options: {
      deep: true,
      handler() {
        this.getStockOrderAnalyzeFromAPI();
      },
    },

    // 仓库组别
    stockDistrictSelected: {
      handler() {
        this.options.stock_districts = this.stockDistrictSelected
          ? this.stockDistrictSelected.code
          : null;
      },
    },
    // 供应商
    supplierSelected: {
      handler() {
        this.options.supply_id = this.supplierSelected
          ? this.supplierSelected.id
          : null;
      },
    },
    // 仓配中心搜索
    stocksSelected: {
      handler() {
        this.options.stock_id = this.stocksSelected
          ? this.stocksSelected.id
          : null;
      },
    },
    // 商品
    materialSelected: {
      immediate: true,
      handler() {
        this.options.material_ids = this.materialSelected
          ? this.materialSelected
          : [];
      },
    },
    outDatetimeRange: {
      handler() {
        this.options.out_create_time_from =
          this.outDatetimeRange.out_create_time_from;
        this.options.out_create_time_to =
          this.outDatetimeRange.out_create_time_to;
        this.options.out_actual_time_from =
          this.outDatetimeRange.out_actual_time_from;
        this.options.out_actual_time_to =
          this.outDatetimeRange.out_actual_time_to;
        this.options.out_finish_time_from =
          this.outDatetimeRange.out_finish_time_from;
        this.options.out_finish_time_to =
          this.outDatetimeRange.out_finish_time_to;
        if (this.timeSyncFlg) {
          this.inDatetimeRange.in_create_time_from =
            this.outDatetimeRange.out_create_time_from;
          this.inDatetimeRange.in_create_time_to =
            this.outDatetimeRange.out_create_time_to;
          this.inDatetimeRange.in_actual_time_from =
            this.outDatetimeRange.out_actual_time_from;
          this.inDatetimeRange.in_actual_time_to =
            this.outDatetimeRange.out_actual_time_to;
          this.inDatetimeRange.in_finish_time_from =
            this.outDatetimeRange.out_finish_time_from;
          this.inDatetimeRange.in_finish_time_to =
            this.outDatetimeRange.out_finish_time_to;
          if (this.outDatetimeRange.datetimeRadioSelected == "out_create")
            this.inDatetimeRange.datetimeRadioSelected = "in_create";
          if (this.outDatetimeRange.datetimeRadioSelected == "out_actual")
            this.inDatetimeRange.datetimeRadioSelected = "in_actual";
          if (this.outDatetimeRange.datetimeRadioSelected == "out_finish")
            this.inDatetimeRange.datetimeRadioSelected = "in_finish";
        }

        sessionStorage.setItem(
          "stockIN-and-stockOUT-outDatetimeRange",
          JSON.stringify(this.outDatetimeRange)
        );
      },
    },
    inDatetimeRange: {
      deep: true,
      handler() {
        this.options.in_create_time_from =
          this.inDatetimeRange.in_create_time_from;
        this.options.in_create_time_to = this.inDatetimeRange.in_create_time_to;
        this.options.in_actual_time_from =
          this.inDatetimeRange.in_actual_time_from;
        this.options.in_actual_time_to = this.inDatetimeRange.in_actual_time_to;
        this.options.in_finish_time_from =
          this.inDatetimeRange.in_finish_time_from;
        this.options.in_finish_time_to = this.inDatetimeRange.in_finish_time_to;

        sessionStorage.setItem(
          "stockIN-and-stockOUT-inDatetimeRange",
          JSON.stringify(this.inDatetimeRange)
        );
      },
    },
    timeSyncFlg: {
      handler() {
        this.outDatetimeRange = Object.assign({}, this.outDatetimeRange);
        this.inDatetimeRange = Object.assign({}, this.inDatetimeRange);
      },
    },
    shopSelected: {
      handler() {
        this.options.shop_id = this.shopSelected ? this.shopSelected.id : "";
        sessionStorage.setItem(
          "stockIN-and-stockOUT-shopSelected",
          JSON.stringify(this.shopSelected)
        );
      },
    },
  },
};
</script>

<style>
</style>